import { Component, input } from '@angular/core';
import { DurationPipe } from 'src/app/pipes/duration.pipe';

@Component({
  selector: 'app-transport-duration',
  standalone: true,
  imports: [
    DurationPipe
  ],
  templateUrl: './transport-duration.component.html',
  styleUrls: ['./transport-duration.component.scss'],
})
export class TransportDurationComponent {
  public duration = input<number>();
}
